import { useDispatch, useSelector } from "react-redux";
import { SetKategori, paketActions } from "../redux/actions/prepareActions";
import { showLog } from "../utils/log";

export default function SubKategory(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state?.dataPrepare);

  function onClickCategory(items) {
    showLog("SubKategoty Masuk onClickCategory");
    let newArr = [...state?.kategory];
    for (const x of newArr) {
      if (x.id == items.id) {
        x["selection"] = true;
      } else {
        x["selection"] = false;
      }
    }
    dispatch(SetKategori(newArr));
    dispatch({
      type: "SET_GET_PAKET",
      value: {
        data: [],
        loading: true,
      },
    });
    dispatch(paketActions());
    // if (items.label == "Promo Paket") {
    //     props.setShowPaket(true)
    // }else {
    //     props.setShowPaket(false)
    // }
  }

  return (
    <div
      className="scrollbar"
      style={{
        margin: "0px 20px 0 20px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        overflow: "auto",
        whiteSpace: "nowrap",
        padding: 5,
      }}
    >
      {state?.kategory?.map((items, index) => (
        <div key={index}>
          <div
            onClick={() => items.Promo == onClickCategory(items)}
            style={{
              backgroundColor: items["selection"] ? "#5451D6" : "#fff",
              marginRight: state?.kategory?.length == index ? 0 : 10,
              padding: "5px 20px",
              borderRadius: 20,
              display:
                items.label !== "Promo Paket" && items.label !== "Promo Diskon"
                  ? "none"
                  : false,
            }}
          >
            <div
              className="fonts500"
              style={{
                color: items["selection"] ? "#fff" : "#5451D6",
                fontSize: 12,
              }}
            >
              {items.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
